module.exports = __webpack_public_path__ + "static/media/icon_enter.71ddc326.png";